import styled from 'styled-components';

export const InfiniteLoaderContainer = styled.div`
    @keyframes spin {
        0% {
            transform: rotate(0);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    .loader {
        animation: spin 2s linear infinite;
        border: 8px solid #fef7ef;
        border-radius: 50%;
        border-top: 8px solid #ff6f61;
        height: 48px;
        margin: 2rem auto 0;
        width: 48px;
    }
`;